import { type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthStorageService } from '@/app/core/services/auth-storage.service';

/**
 * HTTP Interceptor that adds Bearer authentication token to all outgoing requests
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authStorage = inject(AuthStorageService);
  const token = authStorage.getToken();

  // Skip adding token for authentication endpoints
  // Note: /refresh endpoint NEEDS the token, so we don't skip it.
  // Passkey login endpoints are skipped too: authentication is public and
  // registration uses the setup token attached by the generated client
  // (merchantPanelPasskeySetup), which must not be overwritten with the
  // session token. Management endpoints (/login/passkeys[/{id}]) keep the
  // session token.
  const isAuthEndpoint =
    req.url.includes('/login/init') ||
    req.url.includes('/login/emailConfirm') ||
    req.url.includes('/login/phoneConfirm') ||
    req.url.includes('/login/passkeys/authentication/') ||
    req.url.includes('/login/passkeys/registration/');

  // Clone request and add Authorization header if token exists
  if (token != null && token !== '' && !isAuthEndpoint) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(req);
};
